import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface NotificationsState {
  /** Report IDs for which background generation was triggered; we poll until completed and show a notification. */
  pendingReportIds: string[]
}

const initialState: NotificationsState = {
  pendingReportIds: []
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addPendingReportId: (state, action: PayloadAction<string>) => {
      const id = action.payload
      if (!state.pendingReportIds.includes(id)) {
        state.pendingReportIds.push(id)
      }
    },
    removePendingReportId: (state, action: PayloadAction<string>) => {
      state.pendingReportIds = state.pendingReportIds.filter((id) => id !== action.payload)
    }
  }
})

export const { addPendingReportId, removePendingReportId } = notificationsSlice.actions
export default notificationsSlice.reducer
